export const JSONParse = <T = any>(jsonString: string): Partial<T> => {
  try {
    return JSON.parse(jsonString) as Partial<T>;
  } catch (error) {
    console.error("Error parsing JSON string:", error);
    return {};
  }
};
